import React, { forwardRef } from 'react';
import { Label, WrapperInputMask, HelperText, StyledInput } from './styles';
import { PhoneInputRefType } from 'react-international-phone';
import 'react-international-phone/style.css';
import { countries } from '@src/common/phoneInput';

type PhoneInputProps = Omit<JSX.IntrinsicElements['input'], 'name'> & {
  name: string;
  error?: boolean;
  label?: string;
  helperText?: React.ReactNode | string;
  value?: any;
  onChange: (event: { target: { name: string; value: string } }) => void;
};

const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  (props: PhoneInputProps, inputRef: React.Ref<HTMLInputElement>) => {
    const { error = false, label, helperText, name, value, onChange = () => {} } = props;

    return (
      <WrapperInputMask>
        {label ? <Label htmlFor={name}>{label}</Label> : null}

        <StyledInput
          {...props}
          ref={inputRef as React.Ref<PhoneInputRefType>}
          value={value}
          onChange={(v) => onChange({ target: { name, value: `${v}` } })}
          error={error}
          countries={countries}
        />

        {helperText ? <HelperText error={error}>{helperText}</HelperText> : null}
      </WrapperInputMask>
    );
  },
);

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
